import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { fetch, store, update } from "../../../utils/httpUtil";

export const searchHrDetailsWithCriteria = createAsyncThunk(
  "hr/search",
  async (payload) => {
    try {
      const response = await store("v1/hr/search", payload);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const addHrDetails = createAsyncThunk("hr/add", async (payload) => {
  try {
    const response = await store("v1/hr", payload);
    return response?.data?.data;
  } catch (error) {
    throw error;
  }
});

export const updateHrDetails = createAsyncThunk(
  "hr/update",
  async (payload) => {
    try {
      const response = await update(`v1/hr/${payload?.id}/update`, payload?.payload);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchHrDetailsById = createAsyncThunk(
  "hr/detail",
  async (payload) => {
    try {
      const response = await fetch(`v1/hr/${payload?.id}/${payload?.object_type}/detail?is_draft=${payload?.is_draft}`);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchUpdateRequest = createAsyncThunk(
  "hr/update-request",
  async (payload) => {
    try {
      const response = await fetch(`v1/hr/${payload?.id}/${payload?.object_type}/detail`);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

const listPending = ["hr/search/pending"];
const listFulfilled = ["hr/search/fulfilled"];
const listRejected = ["hr/search/rejected"];

const detailPending = [
  "hr/detail/pending",
  "hr/add/pending",
  "hr/update/pending",
  "hr/update-request/pending",
];
const detailFulfilled = [
  "hr/detail/fulfilled",
  "hr/add/fulfilled",
  "hr/update/fulfilled",
  "hr/update-request/fulfilled",
];
const detailRejected = [
  "hr/detail/rejected",
  "hr/add/rejected",
  "hr/update/rejected",
  "hr/update-request/rejected",
];

export const hrDetailSlice = createSlice({
  name: "hrDetail",
  initialState: {
    payload: [],
    loading: false,
    errors: {},
    pagination: {},

    detailPayload: [],
    detailLoading: false,
    detailErrors: {},
  },
  reducers: {
    cleanHrDetail(state) {
      state.payload = [];
      state.loading = false;
      state.errors = {};
      state.pagination = {};
    },
    cleanDetails(state) {
      state.detailPayload = [];
      state.detailLoading = false;
      state.detailErrors = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        (action) => listPending.includes(action.type),
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        (action) => listFulfilled.includes(action.type),
        (state, action) => {
          state.loading = false;
          state.payload = action.payload?.data?.data;
          state.pagination = {
            page_number: action.payload?.data?.pagination?.page_number,
            page_size: action.payload?.data?.pagination?.page_size,
            total_records: action.payload?.data?.pagination?.total_records,
            total_pages: action.payload?.data?.pagination?.total_pages,
            showSizeChanger: true,
          }
        }
      )
      .addMatcher(
        (action) => listRejected.includes(action.type),
        (state, action) => {
          state.loading = false;
          state.errors = action.error;
        }
      )
      .addMatcher(
        (action) => detailPending.includes(action.type),
        (state) => {
          state.detailLoading = true;
        }
      )
      .addMatcher(
        (action) => detailFulfilled.includes(action.type),
        (state, action) => {
          state.detailLoading = false;
          state.detailPayload = action.payload?.data?.data?.[0];
        }
      )
      .addMatcher(
        (action) => detailRejected.includes(action.type),
        (state, action) => {
          state.detailLoading = false;
          state.detailErrors = action.error;
        }
      );
  },
});

export const { cleanHrDetail, cleanDetails } = hrDetailSlice.actions;
export default hrDetailSlice;
